<template>
  <span>
    <b-modal
      size="sm"
      v-model="modal"
      @hide="hideModal"
      title="Brecha Comercial"
    >
      <div class="text-center">
        <b-alert show
          >CREANDO DESDE {{ lotComputed }}-{{ product_name }}<br /><b
            >{{ differenceComputed }} Kg RESTANTES</b
          ></b-alert
        >
      </div>
      <b-row>
        <b-col>
          <b-form-group
            label-cols-sm="8"
            label-cols-lg="8"
            label-class="font-weight-bold"
            label="Orden Fabricación"
          >
            <b-form-input
              type="text"
              required
              autocomplete="off"
              v-model="$v.form.manufacturing_order.$model"
              :state="
                $v.form.manufacturing_order.$dirty
                  ? !$v.form.manufacturing_order.$error
                  : null
              "
              v-on:keyup="inputSoloNumero"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="fieldset-horizontal"
            label-class="font-weight-bold"
            label-cols-sm="8"
            label-cols-lg="8"
            label="Peso promedio recipiente"
            label-for="input-horizontal"
          >
            <b-form-input
              type="text"
              v-model="$v.form.box_avg.$model"
              :state="$v.form.box_avg.$dirty ? !$v.form.box_avg.$error : null"
              step="0.01"
              class="text-right"
              autocomplete="off"
              v-on:keyup="inputSoloNumeroDecimal"
            />
          </b-form-group>
          <p>Brecha total calculada : {{ commercialDiff }}</p>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            :disabled="countIn === 0 || differenceNet <= 0"
            @click.prevent="
              e => {
                e.target.blur();
                onSubmit();
              }
            "
            @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
            class="float-right ml-1"
            >Guardar<!-- /imprimir -->
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <!--  <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button class="float-right ml-1" @click="hideModal"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import { decimal, minValue, required } from "vuelidate/lib/validators";

export default {
  name: "BrechaComercialButton",
  props: {
    lot: {
      type: String,
      default: ""
    },
    lot_id: {
      type: Number,
      default: 0
    },
    fruit_id: {
      type: Number,
      default: 0
    },
    modal: {
      type: Boolean,
      default: false
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    },
    product_code: {
      type: String,
      default: 0
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      modal_title: "",
      form: {
        box_avg: 0,
        manufacturing_order: null
      },
      submitActive: false
    };
  },
  computed: {
    ...mapState("bagnoProcessModule", {
      contents_in: state => state.form.contents_in,
      contents_out: state => state.form.contents_out
    }),
    ...mapGetters("bagnoProcessModule", [
      "totalQuantitySaleable",
      "totalSaleable"
    ]),
    commercialDiff() {
      return this.difference(
        this.form.box_avg * this.totalQuantitySaleable,
        this.totalSaleable
      );
    },
    lotComputed() {
      return this.lot;
    },
    lotId() {
      return this.lot_id;
    },
    productId() {
      return this.product_id;
    },
    differenceComputed() {
      return (this.net_kilograms_sum_in - this.net_kilograms_sum_out).toFixed(
        2
      );
    }
  },
  methods: {
    difference(a, b) {
      return (a - b).toFixed(2);
    },
    hideModal() {
      this.$emit("hideSquareModal");
    },
    resetForm() {
      this.form.box_avg = 0;
      this.form.manufacturing_order = null;
    },
    async addRowsOut() {
      console.log("%o", this.contents_out);

      let indice2 = this.contents_out.findIndex(
        data =>
          data.lot_id === this.lot_id &&
          data.product_type.name === "BRECHA COMERCIAL" &&
          data.product_reference_code === this.product_code
      );

      if (indice2 >= 0) {
        this.loading = false;
        this.$toast.info(
          "ya existe una brecha comercial ingresada para el lote y codigo de producto seleccionado",
          ""
        );
      } else {
        const thisV = this;
        thisV.loading = true;
        const data = {
          net_kilograms: thisV.commercialDiff,
          gross_kilograms: 0,
          process: thisV.$route.params.id,
          lot: thisV.lot_id,
          fruit_id: thisV.fruit_id,
          product_code: thisV.product_code,
          product_name: thisV.product_name,
          waste_type: "BRECHA COMERCIAL",
          container: "-",
          product_id: thisV.product_id,
          quantity: 0,
          is_devolution: false,
          manufacturing_order: parseInt(thisV.form.manufacturing_order)
        };
        if (
          parseFloat(thisV.commercialDiff) >
          parseFloat(thisV.differenceComputed)
        ) {
          thisV.$toast.info(
            "La brecha ingresada supera el total de kilos restantes disponible en el lote",
            ""
          );
          thisV.loading = false;
          thisV.submitStatus = false;
        } else {
          try {
            const response = await thisV.$axios({
              method: "POST",
              url: `bagno/process/${thisV.$route.params.id}/square_up_process/`,
              data: data
            });
            if (response.data.status != "0") {
              thisV.$store.dispatch(
                "bagnoProcessModule/addRowsOut",
                response.data
              );
              thisV.$toast.success(`Brecha comercial creada con éxito`, "");
              thisV.loading = false;
              thisV.hideModal();
              thisV.resetForm();
            } else {
              thisV.$toast.error(
                "Problemas al crear, tipo de producto no encontrado",
                ""
              );
              thisV.loading = false;
            }
          } catch (error) {
            console.log(error);
            thisV.$toast.error("Problemas al crear", "");
            thisV.loading = false;
            thisV.resetForm();
          }
        }
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      this.submitActive = true;
      if (this.$v.$invalid == true) {
        this.$toast.info("Campos restantes en el formulario", "");
        return;
      } else {
        if (this.commercialDiff >= 0) {
          this.addRowsOut();
        } else {
          this.$toast.warn(
            "El campo Brecha total calculada no puede ser negativo",
            ""
          );
        }
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      box_avg: {
        required,
        minValue: minValue(0.01),
        decimal
      },
      manufacturing_order: { required }
    }
  }
};
</script>

<style scoped></style>
